module.exports = __webpack_public_path__ + "img/icoWchance.f360d5af.png";